import { Navigation, ParkingCircle } from "lucide-react";
import { CONTACT_INFO } from "@/data/site";

const directionsUrl = (lieu) => `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(lieu)}`;

export const LieuActions = ({ event, className = "" }) => {
  if (event.type === "voyage" || event.type === "randonnee" || event.type === "mystere_caquelon" || (event.type === "lieu_ancien" && !event.lieu_confirme) || /^En extérieur/.test(event.lieu || "")) return null;
  const isStage = event.type === "stage";
  const destination = event.coordonnees || event.lieu;
  const cls = "inline-flex items-center gap-1.5 font-mono text-[10px] uppercase tracking-[0.2em] text-terra hover:text-earth transition-colors duration-300";
  return (
    <div className={`flex flex-wrap gap-x-5 gap-y-2 ${className}`} data-testid={`lieu-actions-${event.id.slice(0, 8)}`}>
      <a href={directionsUrl(destination)} target="_blank" rel="noopener noreferrer" data-testid={`event-itineraire-${event.id.slice(0, 8)}`} className={cls}>
        <Navigation className="w-3.5 h-3.5" /> Itinéraire
      </a>
      {isStage && (
        <a href={CONTACT_INFO.parking} target="_blank" rel="noopener noreferrer" data-testid={`event-parking-${event.id.slice(0, 8)}`} className={cls}>
          <ParkingCircle className="w-3.5 h-3.5" /> Parking recommandé — Creux-de-Rave
        </a>
      )}
    </div>
  );
};

export const LieuMap = ({ lieu, className = "" }) => (
  <div className={`rounded-xl overflow-hidden border border-sand-dark aspect-[16/7] ${className}`} data-testid="lieu-map">
    <iframe
      title={`Carte — ${lieu}`}
      src={`https://www.google.com/maps?q=${encodeURIComponent(lieu)}&output=embed&hl=fr`}
      className="w-full h-full grayscale-[35%] sepia-[10%]"
      loading="lazy"
    />
  </div>
);
